export function ValidationErrorAsString(validation: Record<string, string>) {
  let s = ''

  Object.keys(validation).forEach((key) => {
    s += `${key}: ${validation[key]}\n`
  })

  return s
}
